import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import { removeAllCookies } from 'services/helper/cookiesHelper'
import Mail from '../assets/mail.svg'
import Timer from '../assets/timer.svg'
import AdxButton from 'components/custom/AdxButton'

const WaitingHrTechVerification = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const handleReturnHomepage = () => {
    navigate('/')
  }

  useEffect(() => {
    if (!state?.email) {
      navigate('/signup')
    }
    removeAllCookies()
  }, [state, navigate])

  return (
    <OnboardingContainer
      srcRightPhoto={Mail}
      bgColorRight="alternate.main"
      topRightPhoto="50%"
      leftRightPhoto="58%"
      heightRightPhoto="57%"
      transformRightPhoto={`translate(${0}%, ${-50}%)`}
    >
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems={{ xs: 'center', lg: 'center' }}
      >
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height={{ xs: '90vh', lg: '500px' }}
          mr={{ lg: 7.6875 }}
          p={{ xs: 2 }}
          position={'relative'}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box mb={4} display="flex" flexDirection="column" alignItems="center" gap={2}>
            <Box component="img" src={Timer} width="80px" />
            <Typography variant="h2">Your request is under review</Typography>
            <Typography variant="body1" textAlign="center" color="light-gray-text.main">
              Thank you for your registration. Your application has been submitted and we’ll review
              it{' '}
              <Typography component="span" fontWeight="bold" color="dark-text.main">
                within 24 hours
              </Typography>
              . You will be notified by email at{' '}
              <Typography component="span" fontWeight="bold" color="dark-text.main">
                {state?.email}
              </Typography>{' '}
              once your application is successful
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap={2} width={1}>
            <AdxButton variant={'contained'} fullWidth onClick={handleReturnHomepage}>
              Return to homepage
            </AdxButton>
            <AdxButton
              variant={'outlined'}
              fullWidth
              href={process.env.REACT_APP_ADNEXIO_PRO_URL + '/contact-us'}
              target="_blank"
            >
              Contact us
            </AdxButton>
          </Box>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default WaitingHrTechVerification
